import React, { Component, Fragment } from 'react'
import { DefaultAnnotationFormConfigs } from '../main'
import permissionService from '../services/permission'
import { deleteAnnotation } from '../services/api'
import globalConfirmation from 'live/services/global-confirmation'
import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'
import ExportAnnotation from './ExportAnnotation'
import { AnnotationExportRegistry } from '../registries'

type Props = {
    event: AnnotationEvent
    onEdit?: (event: AnnotationEvent, FormConfigs: FormConfigs) => void
    onDelete?: (event: AnnotationEvent) => void
}

export default class DefaultAnnotationActions extends Component<Props> {
    delete = () => {
        globalConfirmation.danger(
            <Fragment>
                <span>{i18n('Are you sure you want to delete this note')}</span>
            </Fragment>,
            null,
            () => {
                deleteAnnotation(this.props.event).then(() =>
                    globalNotification.info(i18n('Note successfully deleted'))
                )

                if (typeof this.props.onDelete === 'function') this.props.onDelete(this.props.event)
            }
        )
    }

    render() {
        const { event, onEdit } = this.props
        const allowed = permissionService.canEditAnnotation(event)

        return (
            <div className="live-annotation__actions">
                <ExportAnnotation registry={AnnotationExportRegistry} event={event} />
                {allowed && typeof onEdit === 'function' ? (
                    <span onClick={() => onEdit(event, DefaultAnnotationFormConfigs)}>
                        <i className="far fa-edit" />
                    </span>
                ) : null}
                {allowed ? (
                    <span onClick={this.delete}>
                        <i className="far fa-trash-alt" />
                    </span>
                ) : null}
            </div>
        )
    }
}
